import { useState } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants';
import { globalPrompt } from '@/components/message';
import { useGlobalModel, transPgToPaginationTotal } from '@/model/globalModel';
import { convertRes2Blob } from '@/utils/exportFile';
import { ISearchPage } from '@/types/AppTypes';
import { purchasesService } from './purchasesService';
import { IPurchaseDetail, IPurchasesSearchFields } from './purchasesTypes';

export const usePurchasesModel = createModel(function () {
	const {
		user: { shopId, shopCode },
		setLoadingInfo,
	} = useGlobalModel(({ user }) => [user]);
	/**
	 * 列表
	 */
	//列表数据源
	const [dataSource, setDataSource] = useState<IPurchaseDetail[]>([]);
	//查询条件
	const [searchParam, setSearchParam] = useState<IPurchasesSearchFields>({});
	//分页参数
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//表格多选id值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	//列表查询
	const loadData = async (
		page: ISearchPage = initPgCfg,
		searchValue: IPurchasesSearchFields = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			shopCode,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		let { retData } = await purchasesService.page(searchParams);
		const { records, ...pg } = retData;
		setPgCfg(transPgToPaginationTotal(pg));
		console.log(records,transPgToPaginationTotal(pg))
		setDataSource(records);
		setLoading(false);
	};

	//设置搜索value
	const updateSearchParam = (updateParam: IPurchasesSearchFields) => {
		setSearchParam({ ...searchParam, ...updateParam });
	};

	//重置搜索参数
	const resetSearchParam = () => {
		setSearchParam({});
		setSelectedRowKeys([]);
		loadData(initPgCfg, {});
	};

	//导出
	const exportPurchases = async (searchValue: IPurchasesSearchFields = searchParam) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中' });
		try {
			const searchParams = {
				shopCode,
				...searchValue,
				singleCode: selectedRowKeys?.join(),
				pageSize: -1,
				pageNum: 1,
			};

			let result = await purchasesService.export(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};

	//下载模板
	const downloadTpl = async () => {
		let result = await purchasesService.downloadTpl();
		convertRes2Blob(result);
	};

	//启用 禁用 api
	const disablePurchases = async (id: string) => {
		let { retData } = await purchasesService.disable(id);
		loadData();
		globalPrompt('message', { text: '操作成功', type: 'success' });
	};

	return {
		/***field***/
		searchParam,
		dataSource,
		selectedRowKeys,
		pgCfg,
		loading,
		/***method***/
		setDataSource,
		setSelectedRowKeys,
		resetSearchParam,
		updateSearchParam,
		loadData,
		exportPurchases,
		downloadTpl,
		disablePurchases,
	};
});
